import React from 'react';
export default function JobPosterDownload({ name, title }) {
  return <div className="voice-actions"><a className="jobs-apply" href={`/static/images/jobs/${name}-a4.jpg`} download={`${title}-募集要項-A4横.jpg`}>募集要項をJPGで保存（A4横）</a><small className="jobs-note">1754 × 1240px / 150dpi / 圧縮JPEG</small></div>;
}
